import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OneCikanMarkalar, YeniEklenenler } from "./homepage/KatalogVitrini";
import SonIncelenenler from "../components/SonIncelenenler";
import VitrinTanitim from "./homepage/VitrinTanitim";
import { yerelIsletmeVerisi } from "../data/isletme";

// Açılış bölümünde ve marka şeridinde kullanılan görseller
const heroImage = "/images/slider/marshal.avif";

// Not: bu görseller birden fazla markayı birlikte içeren tanıtım karoları.
// Tam ve adlandırılmış liste /bayilikler sayfasında; burada dekoratif alt kullanılıyor.
const brandLogos = [
  "/images/bayilikler/marshall.png",
  "/images/bayilikler/bosh.jpg",
  "/images/bayilikler/dewalt.jpg",
  "/images/bayilikler/stanley.jpg",
  "/images/bayilikler/knipex.jpg",
  "/images/bayilikler/vitra.jpg",
  "/images/bayilikler/kalekim.jpg",
  "/images/bayilikler/eca.jpg",
  "/images/bayilikler/kale.jpg",
  "/images/bayilikler/makel.jpg",
];

const Home = () => {
  const { t } = useTranslation();

  // Google için yerel işletme bilgisi (adres, saatler, telefon)
  useEffect(() => {
    const etiket = document.createElement("script");
    etiket.type = "application/ld+json";
    etiket.text = JSON.stringify(yerelIsletmeVerisi(window.location.origin));
    document.head.appendChild(etiket);
    return () => etiket.remove();
  }, []);

  const stats = [
    {
      value: t("home.hero.stats.foundedValue"),
      label: t("home.hero.stats.foundedLabel"),
    },
    {
      value: t("home.hero.stats.dealersValue"),
      label: t("home.hero.stats.dealersLabel"),
    },
    {
      value: t("home.hero.stats.storesValue"),
      label: t("home.hero.stats.storesLabel"),
    },
  ];

  const kampanyalar = [
    {
      title: t("home.campaigns.bathroomKitchen.title"),
      brand: t("home.campaigns.bathroomKitchen.brand"),
      image: "/images/homepageimages/newarc-kapak.webp",
      link: "/urunler/vitrifiye-ve-armaturler",
    },
    {
      title: t("home.campaigns.showerSets.title"),
      brand: t("home.campaigns.showerSets.brand"),
      image: "/images/banyo/vitra/vitra-bliss-3f-surgulu-el-dusu-takimi.webp",
      link: "/urunler/dus-setleri",
    },
    {
      title: t("home.campaigns.paintRollers.title"),
      brand: t("home.campaigns.paintRollers.brand"),
      image: "/images/boya/dekor/dekor-eksport-rulo.webp",
      link: "/urunler/boya-rulolari",
    },
    {
      title: t("home.campaigns.basinMixers.title"),
      brand: t("home.campaigns.basinMixers.brand"),
      image: "/images/banyo/eca/eca-life-lavabo-bataryasi.webp",
      link: "/urunler/lavabo-bataryalari",
    },
    {
      title: t("home.campaigns.sealants.title"),
      brand: t("home.campaigns.sealants.brand"),
      image: "/images/homepageimages/selsil-kapak.webp",
      link: "/urunler/sizdirmazlik-urunleri",
    },
    {
      title: t("home.campaigns.interiorPaints.title"),
      brand: t("home.campaigns.interiorPaints.brand"),
      image: "/images/boya/filli/filli-momento-silan.webp",
      link: "/urunler/ic-cephe-boyalari",
    },
  ];

  return (
    <main>
      {/* Öne çıkan yeni ürün(ler) — sayfanın en üstünde */}
      <VitrinTanitim />

      {/* ------------------------------------------------ */}
      {/* AÇILIŞ                                           */}
      {/* ------------------------------------------------ */}
      <section className="border-b border-line bg-canvas">
        <div className="container-page grid gap-12 py-16 lg:grid-cols-2 lg:items-center lg:gap-20 lg:py-24">
          {/* Metin */}
          <div className="text-start">
            <p className="eyebrow">{t("home.hero.eyebrow")}</p>

            <h1 className="mt-5 text-[32px] font-semibold leading-[1.1] tracking-[-0.025em] text-ink sm:text-[42px] lg:text-[50px]">
              {t("home.hero.title")}
            </h1>

            <p className="mt-6 max-w-xl text-[16px] leading-[1.7] text-body">
              {t("home.hero.subtitle")}
            </p>

            <div className="mt-9 flex flex-wrap gap-3">
              <Link to="/urunler" className="btn-primary">
                {t("home.hero.ctaPrimary")}
              </Link>
              <Link to="/iletisim" className="btn-secondary">
                {t("home.hero.ctaSecondary")}
              </Link>
            </div>

            {/* Rakamlar */}
            <div className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-line pt-8">
              {stats.map((stat, i) => (
                <div key={i}>
                  <p className="text-[26px] font-semibold leading-none tracking-tight text-ink">
                    {stat.value}
                  </p>
                  <p className="mt-2 text-[13px] leading-snug text-muted">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Görsel */}
          <div className="overflow-hidden rounded-lg border border-line bg-white">
            <img
              src={heroImage}
              alt="Marshall"
              className="aspect-[4/3] w-full object-contain p-8"
            />
          </div>
        </div>
      </section>

      {/* ------------------------------------------------ */}
      {/* MARKA ŞERİDİ                                     */}
      {/* ------------------------------------------------ */}
      <section className="border-b border-line">
        <div className="container-page py-12 sm:py-14">
          <div className="flex items-center justify-between gap-4">
            <h2 className="eyebrow">{t("home.brands.title")}</h2>
            <Link to="/bayilikler" className="link-arrow text-[13px]">
              {t("home.brands.link")}
              <span aria-hidden="true" className="arrow-forward" />
            </Link>
          </div>

          {/* 10 logo: 2 ve 5 sütunda da tam bölünür, boş hücre kalmaz */}
          <div className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-5">
            {brandLogos.map((src) => (
              <div
                key={src}
                className="flex h-20 items-center justify-center bg-white px-5 sm:h-24"
              >
                <img
                  src={src}
                  alt=""
                  loading="lazy"
                  className="max-h-14 max-w-full object-contain opacity-75 transition-opacity duration-300 hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ------------------------------------------------ */}
      {/* TOPTAN SATIŞ (ŞANTİYE)                           */}
      {/* ------------------------------------------------ */}
      <section id="toptan" className="border-b border-line bg-accent-soft">
        <div className="container-page grid gap-10 py-14 lg:grid-cols-2 lg:items-center lg:gap-16 lg:py-16">
          {/* Metin */}
          <div className="text-start">
            <p className="eyebrow">{t("home.wholesale.eyebrow")}</p>

            <h2 className="mt-4 text-[24px] font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[30px]">
              {t("home.wholesale.title")}
            </h2>

            <p className="mt-4 max-w-xl text-[15px] leading-[1.7] text-body">
              {t("home.wholesale.subtitle")}
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/toptan-teklif" className="btn-primary">
                {t("home.wholesale.ctaPrimary")}
              </Link>
              <a href="tel:+905377981129" className="btn-secondary">
                {t("home.wholesale.ctaSecondary")}
                <span dir="ltr" className="font-normal text-muted">
                  {t("home.wholesale.phone")}
                </span>
              </a>
            </div>
          </div>

          {/* Kapsam */}
          <ul className="grid gap-px overflow-hidden rounded-lg border border-line bg-line">
            {["brick", "cement", "delivery"].map((key) => (
              <li
                key={key}
                className="grid gap-x-5 gap-y-1 bg-white px-6 py-5 text-start sm:grid-cols-[150px_1fr] sm:items-baseline"
              >
                <span className="text-[15px] font-semibold text-ink">
                  {t(`home.wholesale.items.${key}`)}
                </span>
                <span className="text-[14px] leading-snug text-muted">
                  {t(`home.wholesale.items.${key}Note`)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ------------------------------------------------ */}
      {/* ÖNE ÇIKAN MARKALAR (katalogdan canlı)            */}
      {/* ------------------------------------------------ */}
      <OneCikanMarkalar />

      {/* ------------------------------------------------ */}
      {/* MALZEME HESAPLAYICI TANITIMI                     */}
      {/* ------------------------------------------------ */}
      <section className="container-page pt-14 sm:pt-16">
        <div className="relative overflow-hidden rounded-2xl bg-ink px-6 py-10 sm:px-12 sm:py-12">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -end-16 -top-16 h-64 w-64 rounded-full bg-accent/25 blur-3xl"
          />
          <div className="relative grid gap-8 lg:grid-cols-[1.3fr_1fr] lg:items-center">
            <div className="text-start">
              <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-accent">
                {t("calc.teaserEyebrow")}
              </p>
              <h2 className="mt-3 text-[24px] font-semibold leading-tight tracking-[-0.02em] text-white sm:text-[30px]">
                {t("calc.teaserTitle")}
              </h2>
              <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-white/65">{t("calc.teaserText")}</p>
              <Link to="/hesaplayicilar" className="btn-on-dark mt-7 inline-flex">
                {t("calc.teaserCta")}
              </Link>
            </div>
            <ul className="grid grid-cols-3 gap-3">
              {[
                ["boya", "🎨"],
                ["duvar", "🧱"],
                ["seramik", "🔲"],
                ["beton", "🏗️"],
                ["alci", "🪣"],
                ["alcipan", "📐"],
              ].map(([tur, ikon]) => (
                <li key={tur}>
                  <Link
                    to={`/hesaplayicilar?tur=${tur}`}
                    className="flex h-full flex-col items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/5 px-2 py-5 text-center text-[12.5px] font-medium text-white/85 transition-colors hover:border-white/25 hover:bg-white/10"
                  >
                    <span className="text-[28px]" aria-hidden="true">{ikon}</span>
                    {t(`calc.tabs.${tur}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ------------------------------------------------ */}
      {/* ÜRÜNLER                                          */}
      {/* ------------------------------------------------ */}
      <section className="container-page section">
        <h2 className="section-title mb-8">{t("products")}</h2>

        <div className="grid gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
          {kampanyalar.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="group flex flex-col bg-white text-start transition-colors duration-200 hover:bg-canvas"
            >
              <div className="media h-60 w-full bg-white">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="h-full w-full object-contain p-6 transition-transform duration-500 ease-out group-hover:scale-[1.03]"
                />
              </div>

              <div className="flex flex-grow flex-col justify-between border-t border-line p-6">
                <div>
                  {item.brand && <p className="eyebrow">{item.brand}</p>}
                  <h3 className="mt-2 line-clamp-2 text-[16px] font-semibold leading-snug tracking-tight text-ink">
                    {item.title}
                  </h3>
                </div>

                <span className="link-arrow mt-5">
                  {t("home.viewDetails")}
                  <span
                    aria-hidden="true"
                    className="arrow-forward transition-transform duration-200 group-hover:translate-x-0.5"
                  />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ------------------------------------------------ */}
      {/* YENİ EKLENENLER (katalogdan canlı)               */}
      {/* ------------------------------------------------ */}
      <YeniEklenenler />

      {/* Ziyaretçinin son incelediği ürünler (yalnızca kendi tarayıcısında) */}
      <SonIncelenenler />

      {/* ------------------------------------------------ */}
      {/* KAPANIŞ ÇAĞRISI                                  */}
      {/* ------------------------------------------------ */}
      <section className="container-page pb-16 sm:pb-20">
        <div className="rounded-lg bg-ink px-6 py-14 text-center sm:px-14 sm:py-16">
          <h2 className="mx-auto max-w-2xl text-[24px] font-semibold leading-tight tracking-tight text-white sm:text-[30px]">
            {t("home.cta.title")}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-white/60">
            {t("home.cta.subtitle")}
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="btn-on-dark">
              {t("home.cta.primary")}
            </Link>
            <Link to="/stores" className="btn-on-dark-ghost">
              {t("home.cta.secondary")}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
